import { render, staticRenderFns } from "./CalculationsMenu.vue?vue&type=template&id=821ffb38&scoped=true"
import script from "./CalculationsMenu.vue?vue&type=script&lang=js"
export * from "./CalculationsMenu.vue?vue&type=script&lang=js"
import style0 from "./CalculationsMenu.vue?vue&type=style&index=0&id=821ffb38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821ffb38",
  null
  
)

export default component.exports